import each from "lodash/each";

export const parseMetaDictIntoDisplaySettings = (metaDict, displaySettings) => {
  // The metaDict is legacy. The displaySettings is the future.
  // We need to cherry-pick the meta variables for inclusion into displaySettings.

  console.log(metaDict);

  function toBoolean(v) {
    return v === "true";
  }
  function toInt(v) {
    return parseInt(v, 10);
  }
  function toFloat(v) {
    return parseFloat(v);
  }
  // This is where metaDict items are mapped into the main displaySettings.
  var inclusionMapArray = [
    {
      legacyName: "transition_time",
      newName: "globalTransitionTime",
      transform: toFloat
    },
    { legacyName: "transition_type", newName: "globalTransitionType" },
    {
      legacyName: "body_hex",
      newName: "globalBackgroundColor",
      transform: v => {
        return "#" + v;
      }
    },
    {
      legacyName: "custom_width",
      newName: "customWidth",
      transform: toInt
    },
    {
      legacyName: "custom_height",
      newName: "customHeight",
      transform: toInt
    },
    { legacyName: "header_headline", newName: "title" },
    {
      legacyName: "showCaptions",
      newName: "showCaptions",
      transform: toBoolean
    },
    {
      legacyName: "autoShowCaptions",
      newName: "autoShowCaptions",
      transform: toBoolean
    },
    {
      legacyName: "silent_slide_show",
      newName: "fakeAudioPlayback",
      transform: toBoolean
    },
    {
      legacyName: "seconds_per_image",
      newName: "fakeAudioPlaybackSecsPerImage",
      transform: toFloat
    },
    {
      legacyName: "slide_only",
      newName: "noAudio",
      transform: toBoolean
    },
    {
      legacyName: "display_header",
      newName: "showTitle",
      transform: toBoolean
    }
  ];
  each(inclusionMapArray, i => {
    if (i.legacyName in metaDict) {
      if ("transform" in i) {
        displaySettings[i.newName] = i.transform(metaDict[i.legacyName]);
      } else {
        displaySettings[i.newName] = metaDict[i.legacyName];
      }
    }
  });
  // Add customWidth and customHeight if undefined and fullscreen is set.
  if (!displaySettings.customWidth && metaDict.fullscreen == "true") {
    displaySettings.customWidth = 1000;
    displaySettings.customHeight = 667;
  }

  displaySettings.duration = metaDict.duration / 1000;

  return displaySettings;
};
